import type { PuzzleMode } from '../../engine/types';
import { ForgeBoard } from './Board';
import {
  FORGE_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  hint,
  moveFeedback,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type ForgeConfig,
  type ForgeMove,
  type ForgeState,
} from './logic';

export const forgeMode: PuzzleMode<ForgeState, ForgeMove, ForgeConfig> = {
  id: 'forge',
  name: 'Forge',
  tagline: 'Spell words from seven letters',
  description:
    'Build as many words as you can from seven letters. Every word must use the center letter — and a word using all seven is a pangram.',
  accent: 'seed',
  glyph: 'forge',
  howToPlay: [
    { title: 'Use the center', body: 'Every word must contain the highlighted center letter.' },
    { title: 'Reuse freely', body: 'Letters can repeat. Words are 4+ letters (5+ on Thicket).' },
    { title: 'Chase a pangram', body: 'A word that uses all seven letters earns a big bonus.' },
  ],
  difficulties: FORGE_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove,
  moveFeedback,
  handleKey,
  hint,
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: ForgeBoard,
};
